import React from 'react';

import {
  Chip,
  Popover,
  Grid,
  List,
  ListItem,
  ListItemText,
  Icon,
  ListItemSecondaryAction
} from 'e100-react-components';

import { useIntl } from 'react-intl';
import { useMenuState } from 'shared/hooks';
import { usePriceTitle } from '../../hooks';
import { useRouteStationServicesFilterContext } from '../../context';
import { useStyles } from './styles';

import { STATION_SERVICE_PRICE_TYPES } from '../../constants';

export const PriceSelect = () => {
  const { formatMessage } = useIntl();
  const priceTitle = usePriceTitle();
  const classes = useStyles();
  const { showMenu, handleShowMenu, anchorEl, handleCloseMenu } = useMenuState();
  const {
    setActiveStationsServicesPrice,
    isActiveRouteStationsServicesPriceInEUR,
    isActiveRouteStationsServicesPriceInCountry
  } = useRouteStationServicesFilterContext();

  const checkIcon = (
    <ListItemSecondaryAction>
      <Icon
        color="primary"
        kind="done"
        classes={{
          root: classes.icon
        }}
      />
    </ListItemSecondaryAction>
  );

  return (
    <>
      <Chip
        classes={{
          root: classes.chip,
          
        }}
        label={(
          <Grid container wrap="nowrap" alignItems="center" spacing={0}>
            <Grid item>
              {priceTitle}
            </Grid>
            <Grid item>
              <Icon
                kind={showMenu ? "arrowDropUp" : "arrowDropDown"}
                classes={{
                  root: classes.arrowIcon
                }}
              />
            </Grid>
          </Grid>
        )}
        clickable
        variant="outlined"
        onClick={handleShowMenu}
      />
      <Popover
        open={showMenu}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <List>
          <ListItem
            button
            onClick={() => {
              setActiveStationsServicesPrice(STATION_SERVICE_PRICE_TYPES.inCountry);
              handleCloseMenu();
            }}
          >
            <ListItemText
              primary={formatMessage({ id: 'priceInCountryCurrency' })}
              classes={{
                root: classes.listItemText
              }}
            />
            { isActiveRouteStationsServicesPriceInCountry && checkIcon }
          </ListItem>
          <ListItem
            button
            onClick={() => {
              setActiveStationsServicesPrice(STATION_SERVICE_PRICE_TYPES.inEUR);
              handleCloseMenu();
            }}
          >
            <ListItemText
              primary={formatMessage({ id: 'priceInEUR' })}
              classes={{
                root: classes.listItemText
              }}
            />
            { isActiveRouteStationsServicesPriceInEUR && checkIcon }
          </ListItem>
        </List>
      </Popover>
    </>
  );
};
